import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getAudits = actionFactory(types.GET_AUDITS);
